module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst usage = (config || {}).usage || 'management'\nlet insertGranted = (config || {}).insertGranted\nif(insertGranted === undefined){\ninsertGranted = true\n}\nconst entityContext = (config || {}).entityContext || 'address';\nlet exportGranted = (config || {}).exportGranted || false\nif(exportGranted && (storage || {}).user){\nexportGranted = storage.user.hasRoleOption('exportGranted', (config || {}).roleOptionScope || 'art_crm')\n}\nconst assignTagsGranted = !!(config || {}).assignTagsGranted\n%>\n<div>\n<%\nif(usage === 'management'){\n%>\n<section class=\"top\">\n<section class=\"left\">\n<h1><%= storage.__(config.titleKey || ''); %></h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }); %>\n<%\nif(assignTagsGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'assignTagsByFilter', context: entityContext, symbolOnly: false } }); %><%\n}\nif(exportGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'export', context: entityContext, symbolOnly: false } }); %><%\n}\nif(insertGranted){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }); %><%\n}\n%>\n</section>\n</section>\n<%\n}\n%>\n<section class=\"bottom\">\n<%- helpers.renderSection('filter') %>\n<%- helpers.renderSection('list') %>\n</section>\n</div>"
  , __filename = "components/templates/artCrm/entity/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const usage = (config || {}).usage || 'management'
let insertGranted = (config || {}).insertGranted
if(insertGranted === undefined){
insertGranted = true
}
const entityContext = (config || {}).entityContext || 'address';
let exportGranted = (config || {}).exportGranted || false
if(exportGranted && (storage || {}).user){
exportGranted = storage.user.hasRoleOption('exportGranted', (config || {}).roleOptionScope || 'art_crm')
}
const assignTagsGranted = !!(config || {}).assignTagsGranted

    ; __line = 13
    ; __append("\n<div>\n")
    ; __line = 15
    ; 
if(usage === 'management'){

    ; __line = 17
    ; __append("\n<section class=\"top\">\n<section class=\"left\">\n<h1>")
    ; __line = 20
    ; __append(escapeFn( storage.__(config.titleKey || '') ))
    ; __append("</h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n")
    ; __line = 24
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }) )
    ; __append("\n")
    ; __line = 25
    ; 
if(assignTagsGranted){

    ; __line = 27
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'assignTagsByFilter', context: entityContext, symbolOnly: false } }) )
    ; 
}
if(exportGranted){

    ; __line = 30
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'export', context: entityContext, symbolOnly: false } }) )
    ; 
}
if(insertGranted){

    ; __line = 33
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }) )
    ; 
}

    ; __line = 35
    ; __append("\n</section>\n</section>\n")
    ; __line = 38
    ; 
}

    ; __line = 40
    ; __append("\n<section class=\"bottom\">\n")
    ; __line = 42
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 43
    ; __append( helpers.renderSection('list') )
    ; __append("\n</section>\n</div>")
    ; __line = 45
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artCrm/entity/controller.ejs

}